// When editing an existing product
export const setEditableProduct = (product) => {
    return {
        type: "SET_EDITABLE_PRODUCT",
        payload: product
    }
};
